const currencyFormat = {
    format: (number, currencyCode) => {
        return new Intl.NumberFormat('en-US', { style: "currency", minimumFractionDigits: 0, maximumFractionDigits: 0, currency: currencyCode || "USD" }).format(number);
    },
    symbol: (currencyCode) => {
        const locale = "en-US";
        return (0).toLocaleString(locale, { style: 'currency', currency: currencyCode, minimumFractionDigits: 0, maximumFractionDigits: 0 }).replace(/\d/g, '').trim();
    }
};
export default currencyFormat;
